export default "__VITE_ASSET__CpRWuheB__"